import environments from '@utils/environments';
import mixpanel from 'mixpanel-browser';
import { track } from '../utils';

export function trackOrganizationSubmitted(Studio: string) {
  track('Organization Submitted', {
    Studio,
  });
}
export function trackOrganizationFailed(Input: string) {
  track('Organization Failed', {
    Input,
  });
}

export function trackUserLoggedIn(
  Studio: string,
  userId: string,
  Email: string,
) {
  try {
    mixpanel.register({
      Email,
      Studio,
    });
    mixpanel.identify(userId);
    track('User Logged In');
  } catch (_) {
    if (environments.isLocal() || environments.isDev()) {
      // eslint-disable-next-line prefer-rest-params
      console.group('trackUserLoggedIn', arguments);
      console.groupEnd();
    }
  }
}
export function trackUserLoggedOut(Studio: string) {
  track('User Logged Out', {
    Studio,
  });
}
